import type { jsx } from "react/jsx-runtime";
import html from "./html";

export function wrap(input: Function) {
  const wrapped: typeof jsx = (type, props, ...children) => {
    if (typeof type === "string") {
      return input(html[type] || type, props, ...children);
    }

    return input(type, props, ...children);
  };

  return wrapped;
}
